import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-file-drop'
})
export class Ng1FileDropDirective extends UpgradeComponent {
  @Input() url;
  @Input() type;
  @Input() method;
  @Output() refresh = new EventEmitter();

  constructor(elementRef: ElementRef, injector: Injector) {
    super('fileDrop', elementRef, injector);
  }
}

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-file-drop-player'
})
export class Ng1FileDropPlayerDirective extends UpgradeComponent {
  @Input() url;
  @Input() voiceMailFileName;
  @Input() date;
  @Output() refresh = new EventEmitter();
  @Output() remove = new EventEmitter();

  constructor(elementRef: ElementRef, injector: Injector) {
    super('fileDropPlayer', elementRef, injector);
  }
}
